export default "__VITE_ASSET__78db56ef__"